const ADMIN_TOKEN_KEY = 'swi_admin_token'

export function getAdminToken() {
  try {
    return localStorage.getItem(ADMIN_TOKEN_KEY) || ''
  } catch (e) {
    return ''
  }
}

export function isAdminLoggedIn() {
  return Boolean(getAdminToken())
}

export function setAdminToken(token) {
  localStorage.setItem(ADMIN_TOKEN_KEY, token || '')
}

export function clearAdminAuth() {
  localStorage.removeItem(ADMIN_TOKEN_KEY)
}
